import { Tooltip } from "antd";
import { useState } from "react";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const SwalComponent = ({
   message,
   onClickDispatch,
   id,
   postData = {},
   status = false,
   statusValue,
   disabled
}) => {
   const MySwal = withReactContent(Swal);
   const dispatch = useDispatch();
   const [statusType] = useState({
      1: "Active",
      0: "Inactive",
   });

   const handleOnClick = () => {
      MySwal.fire({
         title: message,
         icon: "warning",
         showCancelButton: true,
         focusConfirm: false,
         confirmButtonText: "Yes",
         cancelButtonText: "No",
      }).then(result => {
         /* Read more about isConfirmed, isDenied below */

         if (status && result.isConfirmed) {
            dispatch(onClickDispatch({ postData, updateID: id }));
         } else if (!status && result.isConfirmed) {
            dispatch(onClickDispatch({ deleteID: id }));
         }
      });
   };

   return !status ? (
      <span
         className="fs-6"
         style={{
            color: disabled ? "gray" : statusValue == "1" ? "gray" : "red",
            cursor: disabled ? "not-allowed" : "pointer",
            opacity: disabled ? 0.6 : 1,
         }}
         onClick={e => {
            e.preventDefault();
            if (!disabled) {
               handleOnClick();
            }
         }}
      >
         <Tooltip title={disabled ? "Not allowed" : "Delete"}>
            <i className="icon-trash"></i>
         </Tooltip>
      </span>
   ) : (
      <span
         style={{
            color: statusValue == "1" ? "green" : "red",
            cursor: disabled ? "not-allowed" : "pointer",
            opacity: disabled ? 0.6 : 1,
         }}
         onClick={e => {
            e.preventDefault();
            if (!disabled) {
               handleOnClick();
            }
         }}
      >
         {statusType[statusValue]}
      </span>
   );
};

export default SwalComponent;
